import dashboardData from "./dashboardData.js";
export default {
  dashboardData
};
//# sourceMappingURL=index.js.map